import { render } from "./RestoreSectionOptions.vue?vue&type=template&id=7dc9c8a1&scoped=true&ts=true"
import script from "./RestoreSectionOptions.vue?vue&type=script&lang=ts"
export * from "./RestoreSectionOptions.vue?vue&type=script&lang=ts"

import "./RestoreSectionOptions.vue?vue&type=style&index=0&id=7dc9c8a1&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc9c8a1"]])

export default __exports__